import React, { useEffect, useState, useCallback } from 'react'
import { Bar } from 'react-chartjs-2'
import moment from 'moment'
import { fetchClicksTrending } from '../../../apis/stats'
import Switcher from '../../../components/Util/Switcher'

function ClickTrending(props) {
    const { userInfo, ln_t, className, width } = props
    const { nowEnterprise, lang } = userInfo || {}
    const [data, setData] = useState({})
    const [graphHeight, setGraphHeight] = useState(0)
    const [page, setPage] = useState()
    const [lastPage, setLastPage] = useState()
    const [fullData, setFullData] = useState()

    const graphOpts = {
        legend: {
            display: false
        },
        tooltips: {
            callbacks: {
                title(tooltipItem, data) {
                    const datas = data?.datasets?.[0]?.data
                    const total = datas?.reduce((a, b) => a + b)
                    const index = tooltipItem?.[0]?.index
                    const val = datas?.[index]
                    return `${data.labels?.[index]} (${String(((val / total) * 100).toFixed(1)).replace('.0', '')}%)`
                },
                label(tooltipItem, data) {
                    const datas = data?.datasets?.[0]?.data
                    const index = tooltipItem?.index
                    return `${datas?.[index]?.toLocaleString()} ${ln_t('dashboard.clicks')}`
                },
            },
            titleFontSize: 16,
            bodyFontSize: 16,
            padding: 12,
            displayColors: false,
        },
        scales: {
            xAxes: [{
                scaleLabel: {
                    display: true,
                    labelString: ln_t('dashboard.month'),
                    fontSize: 18,
                }
            }],
            yAxes: [{
                ticks: {
                    beginAtZero: true,
                    userCallback(value) {
                        if (Math.floor(value) === value) {
                            return value.toLocaleString()
                        }
                    }    
                },
                scaleLabel: {
                    display: true,
                    labelString: ln_t('dashboard.clickCount'),
                    fontSize: 18,
                }
            }]
        }
    }    

    const graphRef = useCallback(node => {
        if (!node) return
        const h = node.offsetWidth * 0.8
        setGraphHeight(h)
    }, [width, data])

    const handlePage = newPage => {
        const { labels: fullLabels, datasets } = fullData
        const startIndex = (fullLabels.length - ((lastPage - newPage + 1) * 7)) < 0 ? 0 : (fullLabels.length - ((lastPage - newPage + 1) * 7))
        const endIndex = fullLabels.length - ((lastPage - newPage) * 7)

        if (newPage < 1 || endIndex > fullLabels.length) return

        const d = {
            labels: fullLabels.slice(startIndex, endIndex), 
            datasets: datasets.map(item => ({
                ...item,
                data: item.data.slice(startIndex, endIndex)
            }))
        }
        setData(d)
        setPage(newPage)
    }

    const getDatas = async () => {
        const result = await fetchClicksTrending(nowEnterprise?.enterprise)
        if (result?.status === 200) {
            const x = result.data.sort((a, b) => a.yearMonth - b.yearMonth)

            const months = []
            if (x?.length >= 2) {
                for (let i = moment(String(x[0].yearMonth)); i <= moment(String(x[x.length - 1].yearMonth)); i.add(1, 'month')) {
                    months.push(Number(i.format('YYYYMM')))
                }
            }

            const n = {
                labels: months.map(m => moment(String(m)).format('YYYY-MM')),
                datasets: [{
                    label: 'Clicks',
                    data: months.map(m => {
                        const match = x.find(res => m === res.yearMonth)
                        return match ? match.clicks : 0
                    }),
                    backgroundColor: 'rgba(7, 179, 161, 1)',
                    barThickness: 40,
                }]
            }
            const last = Math.ceil(months.length / 7)
            setLastPage(last)
            setPage(last)
            setFullData(n)
        }
    }

    useEffect(() => {
        if (!fullData || !page) return
        handlePage(page)
    }, [fullData])

    useEffect(() => {
        getDatas()
    }, [lang])

    return (
        <section className={className}>
            <div className="single-bar" ref={graphRef}>
                <h4 className="mb-4">{ln_t('dashboard.mothlyReferralClicksTrend')}</h4>
                <Switcher 
                    className="mb-3 mr-1" 
                    handleLeft={() => handlePage(page - 1)} 
                    handleRight={() => handlePage(page + 1)}
                    disabled={[page <= 1, page >= lastPage]}
                />
                <Bar key={`click-trend_${graphHeight}`} data={data} options={graphOpts} height={graphHeight / 1.5} width={graphHeight} />
            </div>
        </section>
    )
}

export default ClickTrending
